import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '@auth0/auth0-angular';
import { ApiService, MarineSurveyTaskSummary } from '../services/api.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent implements OnInit {
  protected auth = inject(AuthService);
  private api = inject(ApiService);
  private cdr = inject(ChangeDetectorRef);
  protected readonly statusOrder = ['INQUIRY_CREATED'];
  protected tasksByStatus: Record<string, MarineSurveyTaskSummary[]> = {};
  protected loadingTasks = false;
  protected tasksError: string | null = null;
  protected activeConversationId: string | null = null;

  /** Emitted when the user clicks "New Chat". */
  @Output() newChat = new EventEmitter<void>();
  /** Emitted when the user selects a task in the sidebar. */
  @Output() taskSelected = new EventEmitter<string>();

  /** User from Auth0, converted from Observable to signal for template use. */
  protected user = toSignal(this.auth.user$, { initialValue: null });

  protected get hasAnyTasks(): boolean {
    return this.statusOrder.some((status) => (this.tasksByStatus[status]?.length ?? 0) > 0);
  }

  ngOnInit(): void {
    this.loadTasks();
  }

  loadTasks(): void {
    this.loadingTasks = true;
    this.tasksError = null;
    this.cdr.markForCheck();
    this.api.getMarineSurveyTasks().subscribe({
      next: (tasksByStatus) => {
        for (const name of this.statusOrder) {
          this.tasksByStatus[name] = tasksByStatus[name] ?? [];
        }
        console.log(this.tasksByStatus);
        this.loadingTasks = false;
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error('Failed to load marine survey tasks', error);
        this.tasksError = 'Failed to load tasks';
        this.loadingTasks = false;
        this.cdr.markForCheck();
      },
    });
  }

  onNewChat(): void {
    this.activeConversationId = null;
    this.newChat.emit();
  }

  selectTask(conversationId: string): void {
    this.activeConversationId = conversationId;
    this.taskSelected.emit(conversationId);
  }

  formatStatus(status: string): string {
    return status.replace(/_/g, ' ');
  }
}
